<template>
    <div class="detailAudio-view" ref="detailAudioBodyWrapper">
        <div>
            <div v-if="cateName !== 'cateName'" class="detailAudio-view-header">
                <div class="crumbs-nav-mask">
                    <p :style="{color: themeColor}" @click="goCateRoute('all')">
                        {{ langTransfer('全部分类') }}
                    </p>
                    <i :style="{background: themeColor}"/>
                    <p :style="{color: themeColor}" @click="goCateRoute()">{{ cateName }}</p>
                    <i :style="{background: themeColor}"/>
                    <p :style="{color: themeColor}">{{ baseInfo.Name }}</p>
                </div>
            </div>
            <div class="detailAudio-body-wrapper">
                <div class="detailAudio-body">
                    <div class="baseInfo-qrcode-mask">
                        <div class="baseInfo-mask">
                            <img :src="baseInfo.__cover" class="cover-info">
                            <div class="text-infos">
                                <h5>{{ baseInfo.Name }}</h5>
                                <span>{{ langTransfer(baseInfo.__bottomInfo) }}</span>
                                <div class="third-platform-shares">
                                    <img src="https://images.pexels.com/photos/1170831/pexels-photo-1170831.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500">
                                    <img src="https://images.pexels.com/photos/1170831/pexels-photo-1170831.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500">
                                    <img src="https://images.pexels.com/photos/1170831/pexels-photo-1170831.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500">
                                    <img src="https://images.pexels.com/photos/1170831/pexels-photo-1170831.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500">
                                    <img src="https://images.pexels.com/photos/1170831/pexels-photo-1170831.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500">
                                    <img src="https://images.pexels.com/photos/1170831/pexels-photo-1170831.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500">
                                </div>
                                <p>{{ baseInfo.Intro }}</p>
                                <div v-show="catelogList.length > 0"
                                     class="actives"
                                     @click="goPlayer('all')">
                                    <div :style="{background: themeColor}" class="playAll-icon">
                                        <img src="@/assets/playAll.png">
                                    </div>
                                    <i>
                                        {{ langTransfer('开始播放') }}
                                    </i>
                                </div>
                                <button v-if="isNexus.includes('bookcaseoperation')"
                                        :style="{color: themeColor}"
                                        class="addto-bookCase"
                                        @click="bookCaseBtnClick">
                                    {{ bookCaseId === 0 || bookCaseId === undefined ?
                                    langTransfer('+ 加入书架') : langTransfer('- 移出书架') }}
                                </button>
                            </div>
                        </div>
                        <div class="qrcode-mask">
                            <div ref="qrcode"
                                     class="qrcode">
                                     <img ref="qrcodeimag">
                            </div>
                            <p :style="{fontSize: baseInfo.ShortCode ? '' : 0}">
                                {{ langTransfer('(微信)扫码免费借阅') }}
                            </p>
                        </div>
                    </div>
                    <div class="catelog-rec-mask">
                        <div class="catelog-mask">
                            <div class="catelog-header">
                                <div class="header-name">
                                    <i :style="{background: themeColor}" class="warning-icon"/>
                                    <h5>
                                        {{ langTransfer('列表') }}
                                    </h5>
                                </div>
                                <div v-show="catelogList.length > 0" class="header-active-sort">
                                    <p :style="{color: sortIndex === 1 ? themeColor : ''}"
                                       @click="sortIndex = 1">
                                        {{ langTransfer('正序') }}
                                    </p>
                                    <i class="mid-line"/>
                                    <p :style="{color: sortIndex === -1 ? themeColor : ''}"
                                       @click="sortIndex = -1">
                                        {{ langTransfer('倒序') }}
                                    </p>
                                </div>
                            </div>
                            <div class="catelog-body">
                                <div v-for="(item,index) in catelogListData"
                                     :key="index"
                                     class="catelog-item"
                                     @click="goPlayer(item.ID,item.Sequence)"
                                     @mouseenter="hoverCateIndex = index"
                                     @mouseleave="hoverCateIndex = -1">
                                    <div v-if="false" class="isplaying-animation">
                                        <div :style="{background: themeColor}" class="animation-item"/>
                                        <div :style="{background: themeColor}" class="animation-item"/>
                                        <div :style="{background: themeColor}" class="animation-item"/>
                                        <div :style="{background: themeColor}" class="animation-item"/>
                                    </div>
                                    <template v-else>
                                        <i v-if="hoverCateIndex !== index">{{ index + 1 }}</i>
                                        <div v-else class="hover-svg-mask">
                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                 xmlns:xlink="http://www.w3.org/1999/xlink"
                                                 width="12px"
                                                 height="15px"
                                                 viewBox="0 0 12 15"
                                                 version="1.1">
                                                <!-- Generator: Sketch 52.6 (67491) - http://www.bohemiancoding.com/sketch -->
                                                <title>路径</title>
                                                <desc>Created with Sketch.</desc>
                                                <g id="页面-1"
                                                   stroke="none"
                                                   stroke-width="1"
                                                   fill="none"
                                                   fill-rule="evenodd">
                                                    <g id="音频-详情" transform="translate(-193.000000, -555.000000)">
                                                        <g id="hot-copy" transform="translate(150.000000, 484.000000)">
                                                            <g id="item1_hover" transform="translate(16.000000, 58.000000)">
                                                                <g id="播放" transform="translate(26.000000, 13.000000)">
                                                                    <rect id="矩形"
                                                                          fill="#000000"
                                                                          opacity="0"
                                                                          x="0"
                                                                          y="0"
                                                                          width="14"
                                                                          height="14"/>
                                                                    <path id="路径"
                                                                          :fill="themeColor"
                                                                          d="M11.6583847,5.36548779 C13.0839544,
                                                                          6.26819423 13.0831831,7.73225902 11.6583847,
                                                                          8.63447703 L3.85394965,13.5764406 C2.4283799,
                                                                          14.4791471 1.27272727,13.8913648 1.27272727,
                                                                          12.2655499 L1.27272727,1.73441492 C1.27272727,
                                                                          0.10772352 2.42915127,-0.478693811 3.85394965,
                                                                          0.423524186 L11.6583847,5.36548779 Z"/>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        </div>
                                    </template>
                                    <h5 :style="{color: hoverCateIndex === index ? themeColor : ''}">{{ item.Title }}</h5>
                                    <span>{{ item.__duration }}</span>
                                </div>
                                <div v-show="isPending"
                                     class="loader">
                                    <svg id="Layer_1"
                                         version="1.1"
                                         xmlns="http://www.w3.org/2000/svg"
                                         xmlns:xlink="http://www.w3.org/1999/xlink"
                                         x="0px"
                                         y="0px"
                                         width="48px"
                                         height="60px"
                                         viewBox="0 0 24 30"
                                         style="enable-background:new 0 0 50 50;"
                                         xml:space="preserve">
                                        <rect :fill="themeColor"
                                              x="0"
                                              y="10"
                                              width="4"
                                              height="10"
                                              opacity="0.2">
                                            <animate attributeName="opacity"
                                                     attributeType="XML"
                                                     values="0.2; 1; .2"
                                                     begin="0s"
                                                     dur="0.6s"
                                                     repeatCount="indefinite" />
                                            <animate attributeName="height"
                                                     attributeType="XML"
                                                     values="10; 20; 10"
                                                     begin="0s"
                                                     dur="0.6s"
                                                     repeatCount="indefinite" />
                                            <animate attributeName="y"
                                                     attributeType="XML"
                                                     values="10; 5; 10"
                                                     begin="0s"
                                                     dur="0.6s"
                                                     repeatCount="indefinite" />
                                        </rect>
                                        <rect :fill="themeColor"
                                              x="8"
                                              y="10"
                                              width="4"
                                              height="10"
                                              opacity="0.2">
                                            <animate attributeName="opacity"
                                                     attributeType="XML"
                                                     values="0.2; 1; .2"
                                                     begin="0.15s"
                                                     dur="0.6s"
                                                     repeatCount="indefinite" />
                                            <animate attributeName="height"
                                                     attributeType="XML"
                                                     values="10; 20; 10"
                                                     begin="0.15s"
                                                     dur="0.6s"
                                                     repeatCount="indefinite" />
                                            <animate attributeName="y"
                                                     attributeType="XML"
                                                     values="10; 5; 10"
                                                     begin="0.15s"
                                                     dur="0.6s"
                                                     repeatCount="indefinite" />
                                        </rect>
                                        <rect :fill="themeColor"
                                              x="16"
                                              y="10"
                                              width="4"
                                              height="10"
                                              opacity="0.2">
                                            <animate attributeName="opacity"
                                                     attributeType="XML"
                                                     values="0.2; 1; .2"
                                                     begin="0.3s"
                                                     dur="0.6s"
                                                     repeatCount="indefinite" />
                                            <animate attributeName="height"
                                                     attributeType="XML"
                                                     values="10; 20; 10"
                                                     begin="0.3s"
                                                     dur="0.6s"
                                                     repeatCount="indefinite" />
                                            <animate attributeName="y"
                                                     attributeType="XML"
                                                     values="10; 5; 10"
                                                     begin="0.3s"
                                                     dur="0.6s"
                                                     repeatCount="indefinite" />
                                        </rect>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div v-if="cateName !== 'cateName'" class="rec-mask">
                            <h5 class="rec-header">
                                {{ langTransfer('猜你喜欢') }}
                            </h5>
                            <div class="rec-body">
                                <div v-for="(item,index) in userLikeList"
                                     :key="index"
                                     class="rec-item"
                                     @click="goDetail(item)">
                                    <img :src="item.__cover">
                                    <div class="rec-item-infos">
                                        <h5>{{ item.Name }}</h5>
                                        <span :title="item.__bottomInfo">{{ item.__bottomInfo }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="width: 100%;height: 20px;"/>
                    <div class="site-footer">
                        <Footer/>
                    </div>
                </div>
            </div>
        </div>
         <backBtn/>
    </div>
</template>

<script>
    import BScroll from 'better-scroll'
    import QRCode from 'qrcodejs2'
    import backBtn from '@/components/backBtn'
    import Footer from '@/components/footer'
    export default {
        components: {
            backBtn,Footer
        },
        data () {
            return {
                detailAudioBScroll: null,
                cateName: 'cateName',
                sortIndex: -1,
                baseInfo: {},
                catelogList: [],
                isPlayingIndex: -1,
                userLikeList: [],
                lastParams: {},
                hoverCateIndex: -1,
                bookCaseId: undefined,
                isPending: true
            }
        },
        computed: {
            types () {
                const { resourceType } = this
                return this.allTypes[resourceType]
            },
            detailAudioListClassName () {
                const { resourceType } = this
                return {
                    'audio-likely': resourceType === 'audio',
                    'video-likely': resourceType === 'video',
                    'book-likely': resourceType === 'book',
                    'magazine-likely': resourceType === 'magazine'
                }
            },
            catelogListData () {
                const { catelogList, sortIndex } = this
                if (catelogList.length <= 0 || !sortIndex) {
                    return []
                }
                return catelogList.sort(() => {
                    return -1
                })
            },
            playingSequence () {
                return this.$store.state.playingSequence
            },
            themeColor () {
                return this.$store.state.themeColor
            },
            isNexus () {
               return this.$store.state.isNexus
            }
        },
        activated () {
        },
        mounted () {
            this.initBScroll()
        },
        methods: {
            initBScroll () {
                this.$nextTick(() => {
                    this.detailAudioBScroll = new BScroll(this.$refs.detailAudioBodyWrapper, {
                        bounce: false,
                        click: true,
                        mouseWheel: {
                            speed: 20,
                            invert: false,
                            easeTime: 300
                        }
                    })
                })
            },
            initQrCode (text) {
                const ele = this.$refs.qrcode
                ele.innerHTML = ''
                this.qrcode = new QRCode(ele, {
                    width: 222,
                    height: 222,
                    text
                })
            },
            async getShortQCUrl (shortCode) {
                try {
                    let {Data} = await this.$apis('user').getuserisauthorized();
                    if (!Data) {
                        this.$refs.qrcodeimag.src=require('@/assets/defaultqrcode.png');
                        this.$refs.qrcode.className="qrcode qrocdenologin"
                        return;
                    }
                    const data = await this.$apis('shortQC').getShortQCUrl(shortCode)
                    if (data) {
                        this.initQrCode(data)
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async getDetailInfo (params) {
                try {
                    const {
                        id
                    } = params
                    let { Data } = await this.$apis('video').getDetailInfo(id);
                    [Data] = this.$tools.formatVideoData([Data], 1)
                    this.baseInfo = Data
                    this.$nextTick(() => {
                        this.getShortQCUrl(Data.ShortCode)
                    })
                } catch (error) {
                    console.log(error)
                }
            },
            async getDetailCatelog (params) {
                try {
                    this.isPending = true
                    const {
                        id
                    } = params
                    const { Data } = await this.$apis('video').getCatelog(id)
                    if (!Data) {
                        this.catelogList = []
                        return
                    }
                    this.catelogList = Data;
                    this.isPending = false
                } catch (error) {
                    console.log(error)
                }
            },
            async getUserLike (params) {
                try {
                    const {
                        id, cateCode
                    } = params
                    const pageSize = 11
                    const pageIndex = 1
                    const { Data } = await this.$apis('video')
                        .getListByCate(cateCode, pageIndex, pageSize)
                    const __arr = Data.filter((e) => {
                        return e.ID !== id
                    }).slice(0, 10)
                    this.userLikeList = this.$tools.formatVideoData(__arr)
                } catch (error) {
                    console.log(error)
                }
            },
            goPlayer (index,Sequence) {
                /*const { catelogList, baseInfo } = this
                let catelog
                let sequence
                if (index === 'all') {
                    catelog = catelogList
                    sequence = catelogList[0].Sequence
                } else {
                    catelog = [catelogList[index]]
                    sequence = catelogList[index].Sequence
                }*/

                if(index==='all')
                {
                    let _d= this.catelogListData.filter((e)=>{
                        return e.Sequence==1
                    })[0];
                    index = _d.ID;
                    Sequence = 1;
                }

                this.$router.push({ name: 'playerVideo',params: { id: index ,sequence:Sequence}})
                /*const oldId = playerBaseData ? playerBaseData.id : undefined
                if (oldId !== baseInfo.ID) {
                    const baseData = {
                        id: baseInfo.ID,
                        name: baseInfo.Name,
                        cover: baseInfo.ImageUrl
                    }
                    this.$store.commit('setPlayerBaseData', baseData)
                    playerCateLogList = []
                }

                if (playerCateLogList.length > 0 && index !== 'all') {
                    if (!playerCateLogList.find((e) => {
                        return e.Sequence === catelogList[index].Sequence
                    })) {
                        catelog = playerCateLogList.concat([catelogList[index]])
                    } else {
                        catelog = playerCateLogList
                    }
                }

                this.$store.commit('setShowPlayingSequence', sequence)
                this.$store.commit('setPlayerCateLogList', catelog)*/
            },
            goDetail (item) {
                const { cateCode, cateName } = this.$route.params
                let cate
                if (cateCode !== 'cateCode' && cateName !== 'cateName') {
                    cate = {
                        CategoryCode: cateCode,
                        CategoryName: cateName
                    }
                }
                this.$tools.goDetailRoute.call(this, 'video', item, cate)
            },
            bookCaseBtnClick () {
                let userInfos
                try {
                    userInfos = this.$cookies.get('user')
                } catch (error) {
                    console.log(error)
                }
                if (!userInfos) {
                    this.$store.commit('setShowLoginRegister', true)
                    return
                }
                const { bookCaseId } = this
                if (bookCaseId !== 0) {
                    this.removeFromBookCase()
                } else {
                    this.addToBookCase()
                }
            },
            async addToBookCase () {
                try {
                    this.bookCaseId = undefined
                    const {
                        id
                    } = this.$route.params
                    const formData = {
                        resourceid: id,
                        resourcekind: 4
                    }
                    const data = await this.$apis('user').addToBookCase(formData)
                    if (data.Code === 1) {
                        this.bookCaseId = data.Data
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async removeFromBookCase () {
                try {
                    this.bookCaseId = undefined
                    const {
                        id
                    } = this.$route.params
                    const formData = {
                        resourceid: id,
                        resourcekind: 4
                    }
                    const data = await this.$apis('user').removeFromBookCase(formData)
                    if (data.Code === 1) {
                        this.bookCaseId = 0
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async isInUserBookCase (params) {
                try {
                    const { userInfos } = this.$store.state
                    if (!userInfos) {
                        return
                    }
                    const {
                        id
                    } = params
                    const res = {
                        resourceid: id
                    }
                    const { Data } = await this.$apis('user').isInUserBookCase(res)
                    this.bookCaseId = Data
                } catch (error) {
                    console.log(error)
                }
            },
            goCateRoute (all) {
                const {
                    cateCode
                } = this.$route.params
                const params = {
                    resourceType: 'video'
                }
                params.cateCode = all ? 'all' : cateCode

                this.$router.push({
                    name: 'allCates',
                    params
                })
            }
        },
        beforeRouteUpdate (to, from, next) {
            const {
                cateCode, cateName
            } = to.params
            this.baseInfo = {}
            this.catelogList = []
            this.userLikeList = []
            this.cateName = cateName
            if (this.detailPaperBScroll) {
                this.detailPaperBScroll.refresh()
                this.detailPaperBScroll.scrollTo(0, 0)
            }
            this.getDetailInfo(to.params)
            this.getDetailCatelog(to.params)
            this.isInUserBookCase(to.params)
            if (cateCode !== 'cateCode') {
                this.getUserLike(to.params)
            }
            next()
        },
        beforeRouteEnter (to, from, next) {
            next((vm) => {
                const { params } = vm.$route
                if (vm.$tools.isSameParams(params, vm.lastParams)) {
                    return
                }
                vm.lastParams = params
                const {
                    cateCode, cateName
                } = params
                vm.baseInfo = {}
                vm.catelogList = []
                vm.userLikeList = []
                vm.cateName = cateName
                if (vm.detailPaperBScroll) {
                    vm.detailPaperBScroll.refresh()
                    vm.detailPaperBScroll.scrollTo(0, 0)
                }
                vm.getDetailInfo(params)
                vm.getDetailCatelog(params)
                vm.isInUserBookCase(params)
                if (cateCode !== 'cateCode') {
                    vm.getUserLike(params)
                }
            })
        }
    }
</script>

<style lang="scss" scoped>
    .detailAudio-view {
        width: 100%;
        height: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        position: relative;
        overflow: hidden;
    }

    .detailAudio-view-header {
        width: 100%;
        height: 40px;
        box-sizing: border-box;
        background: #F6FAFF;
    }

    .crumbs-nav-mask {
        width: 1140px;
        height: 40px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        p {
            
            font-size: 13px;
            color: #4BA8FF;
            letter-spacing: 0;
            cursor: pointer;
        }

        i {
            width: 1px;
            height: 12px;
            display: block;
            transform: rotate(20deg);
            background: #4BA8FF;
            border-radius: 100px;
            margin: 0 10px;
        }
    }

    .detailAudio-body-wrapper {
        width: 1140px;
        position: relative;
        top: 40px;
        bottom: 0;
        // left: 50%;
        // right: 0;
        //margin-left: -570px;
        //overflow: hidden;
        margin: 0 auto;
        margin-top: 40px;
    }

    .detailAudio-body {
        width: 100%;
        padding-bottom: 138px;
    }

    .baseInfo-qrcode-mask {
        width: 1140px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .qrcode {
        width: 222px;
        height: 222px;
        background: #f6f6f6;
    }

    .baseInfo-mask {
        width: 850px;
        height: 304px;
        box-sizing: border-box;
        padding: 32px 34px;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .cover-info {
        width: 240px;
        height: 240px;
        border-radius: 4px;
        background: #f6f6f6;
    }

    .text-infos {
        width: 518px;
        height: 240px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        position: relative;

        h5 {
            
            font-size: 24px;
            color: #1A1A1A;
            line-height: 24px;
        }

        span {
            
            font-size: 16px;
            color: #8590A6;
            line-height: 16px;
            margin: 10px 0 16px;
        }

        .third-platform-shares {
            height: 36px;
            padding-left: 2px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            opacity: 0;

            img {
                width: 28px;
                height: 28px;
                margin-right: 7px;
                border-radius: 50%;
            }
        }

        p {
            height: 60px;
            
            font-size: 14px;
            color: #79808B;
            letter-spacing: 0;
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            margin: 16px 0 24px;
        }

        .actives {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            .playAll-icon {
                width: 38px;
                height: 38px;
                border-radius: 50%;
                margin-right: 16px;
                cursor: pointer;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
            }

            img {
                width: 20px;
                height: 20px;
                margin-left: 2px;
            }

            i {
                font-style: normal;
                
                font-size: 16px;
                color: #1A1A1A;
                letter-spacing: 0;
                text-align: center;
                line-height: 16px;
                cursor: pointer;
            }
        }

        .addto-bookCase {
            position: absolute;
            right: 0;
            bottom: 10px;
            
            font-size: 14px;
            color: #0084FF;
            letter-spacing: 0;
            text-align: center;
            line-height: 14px;
        }
    }

    .qrcode-mask {
        width: 270px;
        height: 304px;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .qrcode {
            width: 222px;
            height: 222px;
            //background: #f6f6f6;
        }
        .qrocdenologin{
            border: 1px solid #e9e9e9;
            padding: 6px;
            box-sizing: content-box;
        }
        p {
            
            font-size: 14px;
            color: #79808B;
            letter-spacing: 0;
            text-align: center;
            line-height: 14px;
            margin-top: 20px;
        }
    }

    .catelog-rec-mask {
        margin-top: 20px;
        width: 1140px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
    }

    .catelog-mask {
        width:850px;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
    }

    .catelog-header {
        width: 100%;
        height: 50px;
        box-sizing: border-box;
        padding: 0 16px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #F0F2F7;

        .header-name {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
        }

        .warning-icon {
            display: block;
            width: 4px;
            height: 16px;
            margin-right: 8px;
            background: #0084FF;
            border-radius: 2px;
        }

        .header-active-sort {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;

            p {
                
                font-size: 16px;
                color: #1A1A1A;
                line-height: 50px;
                cursor: pointer;
            }

            .mid-line {
                width: 1px;
                height: 16px;
                margin: 0 8px;
                background: #8590A6;
            }
        }
    }

    .catelog-body {
        width: 100%;
        box-sizing: border-box;
        padding: 8px 16px;
    }

    .catelog-item {
        width: 100%;
        height: 40px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;

        i {
            display: block;
            width: 66px;
            text-align: center;
            font-style: normal;
            
            font-size: 14px;
            color: #1A1A1A;
            line-height: 40px;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 12px 14px;
        }

        h5 {
            width: 632px;
            
            font-size: 14px;
            color: #1A1A1A;
            line-height: 40px;
        }

        span {
            display: block;
            width: 140px;
            box-sizing: border-box;
            padding-right: 16px;
            
            font-size: 14px;
            color: #8590A6;
            text-align: right;
            line-height: 14px;
            text-align: right;
        }

        .isplaying-animation {
            width: 66px;
            box-sizing: border-box;
            padding: 0 26px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .animation-item {
                display: block;
                width: 2px;
                height: 18px;
                background: #0084FF;
                border-radius: 1px;
            }

            .animation-item:nth-child(1){
                animation: living .8s linear .1s infinite normal;
                height: 18px;
            }
            .animation-item:nth-child(2){
                animation: living .8s linear .3s infinite normal;
                height: 18px;
            }
            .animation-item:nth-child(3){
                animation: livingBack .8s linear .1s infinite normal;
                height: 8px;
            }
            .animation-item:nth-child(4){
                animation: livingBack .8s linear .3s infinite normal;
                height: 8px;
            }

            @keyframes living{
                0%{height: 18px}
                50%{height: 8px}
                100%{height: 18px}
            }

            @keyframes livingBack{
                0%{height: 8px}
                50%{height: 18px}
                100%{height: 8px}
            }
        }

        .hover-svg-mask {
            width: 66px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
        }
    }

    .catelog-item:hover {
        background: #F6F6F6;

        h5 {
            color: #0084FF;
        }
    }

    .rec-mask {
        width: 270px;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
    }

    .rec-header {
        width: 100%;
        height: 50px;
        box-sizing: border-box;
        padding-left: 16px;
        border-bottom: 1px solid #F0F2F7;
        
        font-size: 16px;
        color: #1A1A1A;
        line-height: 50px;
    }

    .rec-body {
        padding: 8px 0;

        .rec-item {
            height: 74px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;

            img {
                width: 50px;
                height: 50px;
                display: block;
                margin: 0 16px;
            }
        }

        .rec-item-infos {
            height: 50px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;

            h5 {
                
                font-size: 16px;
                color: #1A1A1A;
                line-height: 16px;
                max-width: 172px;
            }

            span {
                display: block;
                
                font-size: 14px;
                color: #8590A6;
                line-height: 14px;
                margin-top: 8px;
                max-width: 172px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .rec-item:hover {
            background: #F6F6F6;
        }
    }

    .site-footer {
        position: absolute;
        bottom: 0;
        left: 0;
        border-top: none;
    }

    .player-wrapper {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start
    }

    .lock-icon {
        width: 20px;
        height: 20px;
        background: saddlebrown;
        align-self: flex-end;
        margin-right: 50px;
    }

    .player-body-mask {
        width: 100%;
        margin: 0 auto;
        background: red;
        height: 0;
        overflow: hidden;
        transition: height .2s;
    }

    .player-body-mask.fix-height {
        height: 80px;
    }

    .player-body {
        height: 100%;
        width: 1140px;
        margin: 0 auto;
        background: yellowgreen;
    }

    .player-wrapper:hover {

        .player-body-mask {
            height: 80px;
        }
    }

    .loader {
        width: 100%;
        height: 90px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
</style>
